// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/components/disabled.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/components/disabled.tsx");
  import.meta.hot.lastModified = "1701884972705.0063";
}
// REMIX HMR END

import React from 'react';
const Disabled = () => {
  const handleContactUs = () => {
    window.open('https://velosmobile.com/contact/', '_blank');
  };
  return <div className="flex flex-col items-center justify-center h-screen">
      <p className="text-2xl text-center mb-4">
        This demo has been disabled. Please contact us to re-enable.
      </p>
      <button className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded" onClick={handleContactUs}>
        Contact Us
      </button>
    </div>;
};
_c = Disabled;
export default Disabled;
var _c;
$RefreshReg$(_c, "Disabled");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;